// extracted by mini-css-extract-plugin
export var pillTrigger = "_65-0";